import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const JobHeader = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1440px;
  height: 768px;
  ${props => props.bg && `background: url(${props.bg}) no-repeat center top`}
  background-attachment: fixed;

  @media screen and (max-width: 980px) {
    background-position-x: center;
  }
`;

export const ContentHeader = styled.div`
  width: 980px;
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 100px;

  h1 {
    color: #fff;
    font-size: 76px;
    font-weight: 600;
    line-height: 80px;
    letter-spacing: -4px;
  }

  @media screen and (max-width: 980px) {
    width: 80%;
  }

  @media screen and (max-width: 414px) {
    padding-bottom: 48px;
    h1 {
      font-size: 56px;
      line-height: 66px;
      letter-spacing: -2px;
    }
  }
`;

export const ContentJob = styled.section`
  width: 100%;
  max-width: 1440px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 960px) {
    width: 100%;
  }

  p {
    font-size: 16px;
    line-height: 24px;
    color: #777777;
    padding-right: 64px;
  }

  h2 {
    color: #272727;
    margin-bottom: 32px;
  }
`;

export const Center = styled.div`
  width: 960px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 64px 0;
  position: relative;

  p.min {
    font-size: 16px;
    line-height: 24px;
    color: #777;
    max-width: 600px;
    margin-bottom: 48px;
    padding: 0;
  }
  @media screen and (max-width: 960px) {
    width: 100%;
    padding: 0 32px;

    img.screen {
      width: 100%;
    }

    p.min {
      max-width: 100%;
      width: 100%;
    }
  }
  @media screen and (max-width: 414px) {
    width: 100%;
    img.design {
      width: 100%;
    }
  }
`;

export const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 54px;
  position: relative;

  &.wrap {
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 0;
  }

  &.right {
    justify-content: flex-end;
  }

  &.column {
    flex-direction: column;
    flex: 0.5;
    @media screen and (max-width: 960px) {
      flex: 0.8;
    }
  }

  a {
    display: flex;
    align-items: center;
    color: #0d4e3b;
    text-transform: uppercase;
    font-family: "Poppins", sans-serif;
    font-weight: 600;

    i {
      margin-right: 8px;
    }
  }
  @media screen and (max-width: 640px) {
    &.first {
      flex-direction: column-reverse;
    }

    p {
      padding-right: 0;
    }

    a {
      position: absolute;
      right: 0;
      top: -60px;
    }
  }
`;

export const DesignSystem = styled.section`
  width: 100%;
  background-color: #f4f4f4;
  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    font-size: 54px;
    line-height: 64px;
    font-weight: 600;
    color: #272727;
    margin-bottom: 32px;
  }

  p {
    font-size: 16px;
    line-height: 20px;
    color: #777;
    max-width: 600px;
    margin-bottom: 48px;
  }
`;
export const DesignItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 64px;
  min-width: 380px;

  h4 {
    font-size: 12px;
    color: #151e52;
    margin-bottom: 16px;
    text-transform: uppercase;
  }

  @media screen and (max-width: 960px) {
    width: 100%;
    min-width: auto;
  }
`;

export const Screens = styled.section`
  width: 100%;
  background-color: #7340ff;
  padding: 64px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .gallery {
    width: 100% !important;
    .slick-slide {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
